import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {notifyLoadFlow, notifyPositionLeft} from '@/helpers/loaderAPI';
import {setFlow} from '@/store/slices/chatbotFlow';
import {
    showChatbotWithDelay,
    showPopupMessageWithDelay,
} from '@/store/slices/chatbotVisibility';
import {apiClient} from '@/helpers/axios';

export const loadChatbot = createAsyncThunk(
    'chatbotDetails/loadChatbot',
    async (_, thunkAPI) => {
        const {UUID} = thunkAPI.getState().chatbotDetails;
        const {isDirectLink} = thunkAPI.getState().chatbotDetails;
        const {isEverOpened} = thunkAPI.getState().chatbotVisibility;
        thunkAPI.dispatch(setLoading(true));
        apiClient.get(`/assistants/${UUID}/detail/`)
            .then(function (response) {
                // handle success
                if (response.status === 200 && response.data.active) {
                    const chatbot = response.data;
                    if (chatbot?.flow?.groups?.length === 0) {
                        console.error(`This chatbot with id: ${UUID} has no message group`);
                        return;
                    }
                    thunkAPI.dispatch(
                        setDetails({
                            settings: chatbot.settings,
                            company: chatbot.company,
                            logo: chatbot.logo,
                        }),
                    );
                    thunkAPI.dispatch(setFlow(chatbot?.flow));
                    thunkAPI.dispatch(setLoading(false));
                    if (chatbot?.settings?.position === 'left') notifyPositionLeft();
                    notifyLoadFlow();
                    if (isDirectLink) {
                        thunkAPI.dispatch(showChatbotWithDelay(5));
                    } else if (chatbot?.settings?.autoPopup && checkPopUpAvailability() && !isEverOpened) {
                        //Apply Chatbot Auto Open (a.k.a autoPopup) setting
                        setTimeout(() => {
                            thunkAPI.dispatch(showChatbotWithDelay(5));
                        }, chatbot?.settings?.secondsUntilPopup * 1000);
                    } else if (chatbot?.settings?.popupMessageEnabled && !isEverOpened) {
                        //Apply Chatbot welcome popup message setting
                        thunkAPI.dispatch(
                            showPopupMessageWithDelay(
                                chatbot?.settings?.secondsUntilPopupMessage * 1000,
                            ),
                        );
                    }
                } else {
                    console.error(`This chatbot with id: ${UUID} is not active`);
                }
            })
            .catch(function (error) {
                console.error(`Couldn\'t load the chatbot with id: ${UUID}. Id could be invalid`, error);
            })
            .finally(() => {
                thunkAPI.dispatch(setLoading(false));
            });
    },
);


const checkPopUpAvailability = () => {
    const lastAccess = localStorage.getItem('last_open') || 0;
    let lastAccessInt = 0;
    try {
        lastAccessInt = parseInt(lastAccess);
    } catch (e) {
        console.error(e);
        lastAccessInt = 0;
    }
    const currentDate = new Date().getTime();
    const msInDay = 24 * 60 * 60 * 1000;
    const diff = (currentDate - lastAccessInt) / msInDay;
    return diff >= 1;
};

const chatbotDetails = createSlice({
    name: 'chatbotDetails',
    initialState: {
        loading: false,
        candidateID: null,
        sourceID: null,
        isDirectLink: false,
        UUID: '',
        settings: {},
        company: {},
        logo: '',
    },
    reducers: {
        setUUID: (state, action) => {
            state.UUID = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setDetails: (state, action) => {
            const {
                settings = {},
                company = {},
                logo = '',
            } = action.payload;
            state.settings = settings;
            state.company = company;
            state.logo = logo;
        },
        setCandidateID: (state, action) => {
            state.candidateID = action.payload;
        },
        setSourceID: (state, action) => {
            state.sourceID = action.payload;
        },
        setIsDirectLink: (state, action) => {
            state.isDirectLink = action.payload;
        },
    },
});

export const {
    setUUID,
    setDetails,
    setLoading,
    setCandidateID,
    setSourceID,
    setIsDirectLink,
} = chatbotDetails.actions;

export default chatbotDetails.reducer;
